export const stripInvalidMbiChars = (mbi) => {
    return (mbi || '').replace(/[^a-z0-9]/gi, '');
};